<template>
  <HubContainer id="lowLevelHub">

    <HubSection large icon="icon/hub/transfer-company.svg"
                :title="$t('advanced_navigation.move_company')"
                :description="$t('advanced_navigation.move_company_description')"
                :buttonAction="goToMoveCompany">
    </HubSection>

    <HubSection large icon="icon/hub/commands.svg"
                :title="$t('advanced_navigation.command_line_runner')"
                :description="$t('advanced_navigation.command_line_runner_description')"
                :buttonAction="goToAdminCommands">
    </HubSection>

    <HubSection large icon="icon/hub/newsletter.svg"
                :title="$t('app_versions.title')"
                :description="$t('app_versions.description')"
                :buttonAction="goToReleaseNotes">
    </HubSection>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "lowLevelHub",

    components: { HubSection, HubContainer },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "advanced_navigation.low_level";
      this.$store.state.pageIcon = "/icon/nav/tools.svg";
    },

    methods: {
      goToAdminCommands() {
        this.$router.push(this.$router.buildContext("/admin-commands"));
      },
      goToMoveCompany() {
        this.$router.push(this.$router.buildContext("/move-company"));
      },
      goToReleaseNotes() {
        this.$router.push(this.$router.buildContext("/app-versions"));
      }
    }
  }
</script>